<icc-list
    [items]="types"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectType($event)"
    [selected]="selectedType$ | async"
></icc-list>
